import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
import "./css/GoogleAlalyticsList.css";
import GoogleAnalyticsMatricsCard from "./components/GoogleAnalyticsMatricsCard";
import { handleApi } from "../../../utils/authentication";
import { getSvgIcons } from "../../../helpers/getReactIcons";
import LeadsBarChart from "../../../components/client/dashboard/LeadsBarChart";
import { useNavigate } from "react-router-dom";

const GoogleAlalyticsList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [googleAnalyticsDomains, setGoogleAnalyticsDomains] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [urlsMatrics, setUrlsMatrics] = useState([]);
  const [isMatricsLoading, setIsMatricsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);

  // Fetching user and filter data from redux store
  const user = useSelector((state) => state?.user);
  const filter = useSelector((state) => state?.filter);
  const navigate = useNavigate();

  const getPorpertiesList = async () => {
    try {
      setIsLoading(true);
      let result = await handleApi(
        "get_google_analytics_properties",
        "GET",
        null,
        null,
      );
      if (result?.success) {
        setGoogleAnalyticsDomains(result?.data?.properties);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const getGoogleAnalyticsDashboardData = async () => {
    try {
      setIsLoading(true);
      let result = await handleApi(
        "get_google_analytics_dashboard_data",
        "GET",
        null,
        null,
      );
      if (result?.success) {
        // console.log(result)
        setDashboardData(result?.data);
        if (result?.data?.domain_list?.length > 0) {
          setSelectedDomain(result?.data?.domain_list[0]);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDomainSelect = async () => {
    setIsMatricsLoading(true);
    try {
      if (selectedDomain?.property_id) {
        const formData = new FormData();
        formData.append("property_id", selectedDomain?.property_id);
        let result = await handleApi(
          "get_google_analytics_property_details",
          "POST",
          null,
          formData,
        );
        if (result?.success) {
          // console.log(result)
          setUrlsMatrics(result?.data?.property_details?.websites);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsMatricsLoading(false);
    }
  };

  useEffect(() => {
    handleDomainSelect();
  }, [selectedDomain]);

  useEffect(() => {
    getPorpertiesList();
    getGoogleAnalyticsDashboardData();
  }, []);

  const metrics = [
    {
      name: "Total Domains Linked",
      value: dashboardData?.total_domain_count ?? 0,
      icon: getSvgIcons("globe", { color: "#9ea8b7", fontSize: "1.3rem" }),
    },
    {
      name: "Total URLs Linked",
      value: dashboardData?.total_urls ?? 0,
      icon: getSvgIcons("link", { color: "#9ea8b7", fontSize: "1.3rem" }),
    },
    {
      name: "Total Visitors",
      value: dashboardData?.total_visitors ?? 0,
      icon: getSvgIcons("people", { color: "#9ea8b7", fontSize: "1.3rem" }),
    },
    {
      name: "Avg. Sessions Duration",
      value: dashboardData?.avg_session_duration.toFixed(2) ?? 0,
      icon: getSvgIcons("clock", { color: "#9ea8b7", fontSize: "1.3rem" }),
    },
  ];

  return (
    <>
      {!user?.status && (
        <div className="d-flex justify-content-center align-items-center">
          <div className="d-flex flex-column gap-2">
            <h5>Your account is Not Active</h5>
            <p>Please contact your administrator</p>
          </div>
        </div>
      )}
      {user?.status && (
        <div className="campaigns">
          {/* {isLoading ? (
        <LoadingSpinner />
      ) : googleAnalyticsDomains.length === 0 ? (
        <div className="text-center">
          <h5>No Domains found</h5>
        </div>
      ) : (
        <div className="custom-accordion mb-5 " id="accordionExample">
          {googleAnalyticsDomains.map((domain) => (
            <div className="custom-accordion-item" key={domain.property_id}>
              <button
                className={`custom-accordion-header ${selectedDomain === domain.property_id ? "show" : "collapsed"}`}
                onClick={() => setSelectedDomain(domain)}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${domain.property_id}`}
                aria-expanded={selectedDomain === domain.property_id ? "true" : "false"}
                aria-controls={`collapse${domain.property_id}`}
              >
                <div className="d-flex justify-content-between w-100 me-3">
                  <span>Domain : {domain.display_name}</span>
                  <span className="small d-flex gap-3 align-items-center">
                    {domain.attached_urls} Attached URL
                    <span className={`toggle-arrow ${selectedDomain === domain.property_id ? "up" : "down"}`}></span>
                  </span>
                </div>
              </button>
              <div
                id={`collapse${domain.property_id}`}
                className={`custom-accordion-collapse collapse ${selectedDomain === domain.property_id ? "show" : "collapsed"}`}
                aria-labelledby={`heading${domain.property_id}`}
                data-bs-parent="#accordionExample"
              >
                <div className="custom-accordion-body d-flex flex-column gap-3 p-3">
                  {isMatricsLoading && selectedDomain === domain.property_id ? (
                    <div className="d-flex align-items-center justify-content-center" style={{ height: "100px" }}>
                      <LoadingSpinner />
                    </div>
                  ) : urlsMatrics.length > 0 ? (
                    urlsMatrics.map((urlData, index) => (
                      <GoogleAnalyticsMatricsCard key={index} urlPageData={urlData} />
                    ))
                  ) : (
                    <div className="d-flex align-items-center justify-content-center" style={{ height: "100px" }}>
                      <h5>No URLs found</h5>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )} */}

          {/* new ui google analytics */}
          <div className="google_analytics_main">
            <section className="header_section">
              <h4>Google Analytics Dashboard</h4>
              <p>Overview of your domains and traffic analytics</p>
            </section>
            <section className="total_metrics_section">
              {isLoading ? (
                <LoadingSpinner />
              ) : metrics.length === 0 ? (
                <div className="text-center">
                  <h5>No Metrics found</h5>
                </div>
              ) : (
                metrics?.length > 0 &&
                metrics?.map((data) => {
                  return (
                    <div className="total_metrics_card">
                      <div className="total_metrics_card_top">
                        <p>{data?.name ?? "--------"}</p>
                        <p>{data?.icon}</p>
                      </div>
                      <h4>{data?.value}</h4>
                    </div>
                  );
                })
              )}
            </section>
            <section className="connected_domains_section">
              <div className="connected_domains_container">
                <div className="connected_domains_heading">
                  <h4>Connected Domain Names</h4>
                </div>
                <div className="connected_domains_metrics_container">
                  <div className="connected_domains_tab_container">
                    {dashboardData?.domain_list?.length > 0 &&
                      dashboardData?.domain_list?.map((tab) => {
                        return (
                          <div
                            className="connected_domains_tab"
                            onClick={() => setSelectedDomain(tab)}
                            style={
                              tab?.domain_name == selectedDomain?.domain_name
                                ? { border: "2px solid " }
                                : {}
                            }
                          >
                            <div
                              className="heading"
                              style={{ cursor: "pointer" }}
                            >
                              <span>
                                {getSvgIcons("globe", {
                                  color: "#9ea8b7",
                                  fontSize: "1.3rem",
                                })}
                              </span>
                              <a
                                style={{
                                  textDecoration: "none",
                                  color: "#212529",
                                }}
                                href={tab?.domain_name}
                              >
                                <span>{tab?.domain_name}</span>
                              </a>
                            </div>
                            <div className="metrics">
                              <span>{tab?.total_urls} URLs</span>
                              <span>
                                {getSvgIcons("arrow-up-right", {
                                  fontSize: "1.2rem",
                                })}
                              </span>
                              <span>{tab?.increment_percentage ?? 0}%</span>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                  <div className="connected_domains_metrics_table_container">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>URL Path</th>
                          <th>Page Views</th>
                          <th>Unique Visitors</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {urlsMatrics?.map((data) => {
                          return (
                            <tr>
                              <td className="d-flex align-items-center gap-2">
                                <a href={data?.website_url}>
                                  {getSvgIcons("link", {
                                    color: "#9ea8b7",
                                    fontSize: "1rem",
                                  })}
                                </a>
                                {data?.website_url}
                              </td>
                              <td>{data?.screen_page_views}</td>
                              <td>{data?.total_users}</td>
                              <td>
                                <span
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    navigate(
                                      `view-more/?property_id=${data?.property_id}&website_url=${data?.website_url}`,
                                    );
                                  }}
                                >
                                  View More
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </section>
            <section className="top_performing_urls_section">
              <div className="top_performing_urls_container">
                <div className="top_performing_urls_heading">
                  <h4> Top Performing URLs</h4>
                </div>
                <div className="top_performing_urls_metrics_container">
                  {isLoading ? (
                    <LoadingSpinner />
                  ) : urlsMatrics.length === 0 ? (
                    <div className="text-center">
                      <h5>No Metrics found</h5>
                    </div>
                  ) : (
                    urlsMatrics.slice(0, 2).map((metrics) => {
                      return (
                        <div className="top_performing_urls_metrics_card">
                          <div className="top_performing_urls_metrics_card_top">
                            <span>
                              <a href={metrics?.website_url}>
                                {getSvgIcons("link", {
                                  color: "#9ea8b7",
                                  fontSize: "1rem",
                                })}
                              </a>
                            </span>
                            <div>
                              <p>{metrics?.website_url}</p>
                              <span>{selectedDomain?.domain_name}</span>
                            </div>
                          </div>
                          <div className="top_performing_urls_metrics_card_bottom">
                            <div>
                              <p>{metrics?.screen_page_views}</p>
                              <span>Page views</span>
                            </div>
                            <div>
                              <p>{metrics?.total_users}</p>
                              <span>Unique Visitors</span>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </section>
            {/* <section className="traffic_overview_section">
          <div className="traffic_overview_section_container">
            <div className="traffic_overview_section_heading">

              <h4>Traffic Overview</h4>
            </div>
            <div className="traffic_overview_section_graph_container">

              <LeadsBarChart />
            </div>

          </div>
        </section> */}
          </div>
        </div>
      )}
    </>
  );
};

export default GoogleAlalyticsList;
